import { useState } from "react"
import apiAtuth from "../../services/apis/apiAuth"

export function MicrosoftLoginButton() {
  const [isLoading, setIsLoading] = useState(false)

  const handleMicrosoftLogin = async () => {
    setIsLoading(true)

    try {
      const res = await apiAtuth.entraIdLogin();
      window.location.href = res.data;
    } catch (error) {
      console.error("Erro ao iniciar login com Microsoft:", error)
      setIsLoading(false)
    }
  }

  return (
    <button
      onClick={handleMicrosoftLogin}
      disabled={isLoading}
      className="rounded-3xl w-full h-10 shadow-2xl cursor-pointer bg-gradient-to-t from-cyan-500 to-blue-700 hover:from-cyan-600 hover:to-blue-800 text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      type="button"
    >
      <div className="flex items-center justify-center space-x-3">
        <MicrosoftIcon />
        <span className="font-bold">{isLoading ? "Conectando..." : "ENTRAR COM CONTA MICROSOFT"}</span>
      </div>
    </button>
  )
}

function MicrosoftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
      <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
    </svg>
  )
}
